import {I18NInterface} from '@/services/enumTranslator/I18NInterface';
import {I18N} from '@/services/enumTranslator/I18NDictionary';

export const I18NGetter: () => I18NInterface = () => I18N.dict;
